import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

const PERMANENT_WARNING_ICON_SIZE = "18px";
const SOURCE_ICON_SIZE = "30px";

export const useMicrosoftTeamsTabStyles = makeStyles({
  description: {
    display: "block",
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
    lineHeight: designTokens.lineHeight.relaxed,
    margin: 0,
  },
  sourceGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: designTokens.spacing[3],
    marginTop: designTokens.spacing[4],
  },
  sourceCard: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "flex-start",
    gap: designTokens.spacing[2],
    padding: designTokens.spacing[2],
    textAlign: "left" as const,
    borderRadius: designTokens.borderRadius.lg,
    border: `1px solid ${designTokens.neutral[200]}`,
    backgroundColor: designTokens.neutral.white,
    cursor: "pointer",
    transition: `all ${designTokens.transition.fast}`,
    ":hover": {
      border: `1px solid ${designTokens.neutral[300]}`,
      backgroundColor: designTokens.neutral[50],
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
    },
  },
  sourceCardSelected: {
    border: `1px solid ${designTokens.accent[500]}`,
    backgroundColor: designTokens.accent[50],
    ":hover": {
      border: `1px solid ${designTokens.accent[500]}`,
      backgroundColor: designTokens.accent[50],
    },
  },
  sourceCardDisabled: {
    opacity: 0.55,
    cursor: "not-allowed",
    ":hover": {
      border: `1px solid ${designTokens.neutral[200]}`,
      backgroundColor: designTokens.neutral.white,
    },
  },
  connectedNotice: {
    display: "flex",
    flexDirection: "column" as const,
    gap: designTokens.spacing[3],
    marginTop: designTokens.spacing[4],
    color: designTokens.neutral[900],
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.semibold,
  },
  connectedNoticeHeader: {
    display: "flex",
    alignItems: "flex-start",
    gap: designTokens.spacing[3],
  },
  connectedTeamCard: {
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    borderRadius: designTokens.borderRadius.lg,
    border: `1px solid ${designTokens.neutral[200]}`,
    backgroundColor: designTokens.neutral.white,
  },
  connectedNoticeText: {
    fontSize: designTokens.fontSize["2xs"],
    color: designTokens.neutral[900],
    lineHeight: designTokens.lineHeight.relaxed,
  },
  sourceHeader: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
  },
  sourceIconTile: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: SOURCE_ICON_SIZE,
    height: SOURCE_ICON_SIZE,
    borderRadius: designTokens.borderRadius.md,
    backgroundColor: designTokens.neutral[100],
    color: designTokens.neutral[500],
    fontSize: designTokens.fontSize.lg,
  },
  sourceIconTileSelected: {
    backgroundColor: designTokens.accent[500],
    color: designTokens.neutral.white,
  },
  sourceTitle: {
    display: "block",
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.bold,
    color: designTokens.neutral[900],
  },
  sourceDescription: {
    display: "block",
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
    marginTop: designTokens.spacing[1],
  },
  permanentWarning: {
    display: "flex",
    alignItems: "flex-start",
    gap: designTokens.spacing[3],
    marginTop: designTokens.spacing[4],
    padding: designTokens.spacing[3],
    borderRadius: designTokens.borderRadius.lg,
    border: `1px solid ${designTokens.semantic.warningBorder}`,
    backgroundColor: designTokens.semantic.warningBackground,
    color: designTokens.semantic.warning,
  },
  permanentWarningIcon: {
    flexShrink: 0,
    width: PERMANENT_WARNING_ICON_SIZE,
    height: PERMANENT_WARNING_ICON_SIZE,
  },
  permanentWarningText: {
    margin: 0,
    fontSize: designTokens.fontSize["2xs"],
    color: designTokens.semantic.warningText,
    lineHeight: designTokens.lineHeight.relaxed,
  },
});
